<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <header-template>
        <template #filterByStatus>
          <hc-phong-hop-state-header
            :state="advanceSearchForm.state"
            :pageTitle="pageTitle"
            :stateOptions="stateOptions"
            @doFilter="stateChanged"
          />
        </template>
      </header-template>
    </template>

    <template #view>
      <div class="view view-with__extendBar">
        <div class="list-docs wrapper-content__main">
          <!--Header-->
          <sub-header>
            <template #content>
              <div class="leftSection flex-row flex__left">
                <el-button
                  size="medium"
                  type="success"
                  class="createNew"
                  v-if="advanceSearchForm.hcFlowId !== null"
                  @click="openCreateDialog()"
                >
                  <div class="flex-row flex__center">
                    <i class="fas fa-plus-circle font-size__large"></i>
                    <span>&nbsp;&nbsp;THÊM MỚI</span>
                  </div>
                </el-button>

                <!--                <el-button-->
                <!--                  class="btnSolid__blue"-->
                <!--                  size="medium"-->
                <!--                  @click="openReportDialog"-->
                <!--                  v-if="isAbleToApprove"-->
                <!--                >-->
                <!--                  <i class="fas fa-file-export"></i>-->
                <!--                  &nbsp;Xuất báo cáo-->
                <!--                </el-button>-->
              </div>

              <searchTemplate
                :keyword="keyword"
                :isDisableAdvanceSearch="true"
                @simpleSearch="simpleSearch"
              >
                <template #quickFilter>
                  <div
                    class="flex-row flex-left__top fix-width__large margin-right-10 custom-label__input"
                    v-if="isQLPhongHop"
                  >
                    <span class="label-input width__auto">Ngày tạo: </span>
                    <el-date-picker
                      v-model="createTimeRange"
                      type="daterange"
                      format="dd/MM/yyyy"
                      class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                      :picker-options="dateQuickFilterOption"
                      range-separator="_"
                      start-placeholder="_"
                      end-placeholder="_"
                      align="center"
                      :clearable="false"
                      @change="filterByCreateTimeRange"
                    >
                    </el-date-picker>
                  </div>

                  <div
                    class="margin-right-10 txt-center fix-width__large"
                    v-if="isQLPhongHop"
                  >
                    <multiselect
                      :class="[deptsFilter ? '' : '', 'style-fullWidth']"
                      :options="deptsFilters"
                      label="name"
                      track-by="id"
                      v-model="deptsFilter"
                      :preselect-first="true"
                      placeholder="-"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :searchable="true"
                      open-direction="bottom"
                      @input="filterByDepartment"
                    >
                      <template slot="noResult"
                      >Không tìm thấy dữ liệu phù hợp.
                      </template>
                      <template slot="noOptions"
                      >Danh sách trống
                      </template>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <div
                          class="status-doc flex-row flex__left font-size__medium"
                        >
                          &nbsp;&nbsp;

                          <span>{{ option.name }}</span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </template>
              </searchTemplate>
            </template>
          </sub-header>

          <!--Content-->
          <div class="list">
            <!-- header-title -->
            <div class="header-title flex-row flex__between margin-bottom-10">
              <div class="leftSection flex-row flex__left">
                <div class="theTitle theTitle__lv5 flex-row flex__center">
                  STT
                </div>
                <div
                  class="theTitle theTitle__lv1 flex-row flex__left padding-left-10"
                >
                  Tiêu đề
                </div>
              </div>

              <div class="rightSection flex-row flex__right">
                <template v-if="isQLPhongHop">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__around"
                  >
                    Thời gian bắt đầu
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__around"
                  >
                    Thời gian kết thúc
                  </div>
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__around"
                  >
                    Đơn vị đăng ký
                  </div>
                </template>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__around margin-right-10"
                >
                  Trạng thái
                </div>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__right padding-right-10"
                  @click="doSort('createTime')"
                >
                  Ngày tạo
                  <sort-caret
                    :order="order"
                    :sort="sort"
                    :field="'createTime'"
                  />
                </div>
              </div>
            </div>
            <!-- list-data -->
            <VuePerfectScrollbar
              class="scroll-area"
              :settings="perfectScrollbarSetting"
              infinite-wrapper
            >
              <div class="list-docs">
                <div
                  v-for="(item, $itemIndex) in items"
                  v-bind:key="$itemIndex"
                  class="item flex-row flex__between"
                >
                  <div
                    class="leftSection flex-row flex__left clickable"
                    @click="viewDetail(item)"
                  >
                    <div class="theTitle__lv5">
                      <div class="flex-row flex__left">
                        <div class="section-check">
                          <span class="stt flex-row flex__center">{{
                            $itemIndex + 1
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="theTitle__lv1 margin-right-10">
                      <div class="title-docs flex-col flex__left">
                        <div class="tt_1 clickable">{{ item.caseTitle }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="rightSection flex-row flex__right">
                    <template v-if="isQLPhongHop">
                      <div
                        class="theTitle__lv3 flex-row flex__around padding-left-10 font-size__small"
                      >
                        <span>{{
                          item.startTime | dateFormatter({ nullValue: "-" })
                        }}</span>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__around padding-left-10 font-size__small"
                      >
                        <span>{{
                          item.endTime | dateFormatter({ nullValue: "-" })
                        }}</span>
                      </div>
                      <div
                        class="theTitle__lv2 flex-row flex__around padding-left-10 font-size__small"
                      >
                        <span>{{ item.requestDeptName }}</span>
                      </div>
                    </template>
                    <div
                      class="theTitle__lv3 flex-row flex__around padding-left-10 font-size__small"
                    >
                      <hc-phong-hop-state
                        :state="item.currentStateCode"
                        :isNewFlow="item.isNewFlow"
                        :isLichTuanTo="!!(item.hcCaseCalendarId)"
                      />
                    </div>
                    <div
                      class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                    >
                      <div class="flex__between">
                        <span>{{
                          item.createTime | dateFormatter({ nullValue: "-" })
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <infinite-loading
                  ref="infiniteLoading"
                  spinner="spiral"
                  @infinite="infiniteHandler"
                >
                  <div slot="no-more"></div>
                  <div slot="no-results">Không có dữ liệu</div>
                </infinite-loading>
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>

        <slot name="extend"></slot>
      </div>
      <div class="extendBar">
        <div class="extendItem" @click="viewCalendar">
          <el-tooltip class="item" effect="dark" content="Xem lịch đặt phòng họp" placement="top">
            <img src="../../../assets/img/new-symbol/Calender.svg" alt="calendar-icon">
          </el-tooltip>
        </div>
      </div>
    </template>
  </listTemplate>
</template>
<script type="text/javascript">
  import listTemplate from "../../common/list";
  import searchTemplate from "../../common/search.vue";
  import headerTemplate from "../../../components/header/main-header.vue";
  import utils from "../../../services/utils";
  import hanhchinhService from "../../../services/hanhchinhService";
  import constants from "../../../constants";
  import dateUtils from "../../../dateUtils";
  import hcMasterCaseRequestViewService from "../../../services/hanhchinh/hcMasterCaseRequestViewService";
  import SortCaret from "../../doc-out/SortCaret";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import dateFormatter from "../../../filters/dateFormatter";
  import goBackMixin from "../../../mixins/goBackMixin";
  import h from "../../../services/h";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import hcFlowService from "../../../services/hcFlowService";
  import SubHeader from "../../../components/main/sub-header";
  import HcPhongHopStateHeader from "./hc-phonghop-state-header";
  import HcPhongHopState from "./hc-phonghop-state";
  import departmentService from "../../../services/departmentService";

  export default {
    name: "hc-base-index",
    mixins: [goBackMixin],
    props: ["pageTitle", "flowCode", "roleCode", "isNewFlow", "defaultStateOptions"],
    components: {
      HcPhongHopState,
      HcPhongHopStateHeader,
      SubHeader,
      SortCaret,
      listTemplate,
      headerTemplate,
      searchTemplate,
      VuePerfectScrollbar
    },

    filters: {dateFormatter},

    data() {
      return {
        advanceSearchForm: {
          keyword: null,
          // filterStatus: null,
          startTime: null,
          endTime: null,
          hcFlowId: null,
          state: null
        },
        createTimeRange: null,
        keyword: null,
        items: [],
        page: 0,
        size: 10,
        sort: "updateTime",
        order: "desc",
        stateOptions: null,

        hcFlowsWhichCanApprove: null,
        dateQuickFilterOption: {
          shortcuts: [
            {
              text: "Hôm nay",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.HOM_NAY
                  )
                );
              }
            },
            {
              text: "Tuần này",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.TUAN_NAY
                  )
                );
              }
            },
            {
              text: "Năm nay",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.NAM_NAY
                  )
                );
              }
            },
            {
              text: "1 tuần trước",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.LAST_WEEK
                  )
                );
              }
            },
            {
              text: "1 tháng trước",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
                  )
                );
              }
            },
            {
              text: "1 năm trước",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
                  )
                );
              }
            }
          ]
        },
        deptsFilters: [{ id: null, name: "Tất cả", level: 0 }],
        deptsFilter: null,
      };
    },

    watch: {},

    computed: {
      isAbleToApprove() {
        return this.hcFlowsWhichCanApprove && this.hcFlowsWhichCanApprove.length;
      },

      isQLPhongHop() {
        return this.roleCode === constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP;
      }
    },

    async created() {
      this.initQuery();
      await this.getProcedureInformation();
      this.registerEventBusForMaster(event => {
        this.doSearch();
      });
      await this.loadHcFlowWhichUserCanApprove();
      this.initStateOptions();
      this.loadDepartments();
    },

    destroyed() {
      this.unregisterEventBusForMaster();
    },

    methods: {
      filterByCreateTimeRange() {
        console.log('chon ngày')
        this.advanceSearchForm.startTime =
          this.createTimeRange && this.createTimeRange[0]
            ? this.createTimeRange[0].getTime()
            : undefined;
        this.advanceSearchForm.endTime =
          this.createTimeRange && this.createTimeRange[1]
            ? this.createTimeRange[1].getTime()
            : undefined;
        this.doSearch();
      },

      filterByDepartment(event) {
        this.advanceSearchForm.requestDeptId = event.id;
        this.doSearch();
      },

      openReportDialog() {
        this.$emit("openReportDialog");
      },

      loadHcFlowWhichUserCanApprove() {
        return hcFlowService
          .findAllHcCaseCommonFlowWhichUserCanApprove(this.flowCode)
          .then(response => (this.hcFlowsWhichCanApprove = response.data));
      },

      initStateOptions() {
        let stateOptions = [];
        if(this.isAbleToApprove > 0 || this.isNewFlow === 0) {
          stateOptions = [
            "-1",
            constants.HC_STATE.STATE_CODE.PHONG_HOP.CHO_PHE_DUYET,
            constants.HC_STATE.STATE_CODE.PHONG_HOP.DA_PHE_DUYET,
            constants.HC_STATE.STATE_CODE.PHONG_HOP.HUY
          ]
        } else {
          stateOptions = [
            "-1",
            constants.HC_STATE.STATE_CODE.PHONG_HOP.CHO_LANH_DAO_PHE_DUYET,
            constants.HC_STATE.STATE_CODE.PHONG_HOP.CHO_PHE_DUYET,
            constants.HC_STATE.STATE_CODE.PHONG_HOP.DA_PHE_DUYET,
            constants.HC_STATE.STATE_CODE.PHONG_HOP.HUY
          ]
        }

        this.stateOptions = h.collect(
          stateOptions,
          state => {
            return {
              id: state,
              name:
                state === "-1"
                  ? "Tất cả"
                  : hanhChinhUtils.getPhongHopStateLabel(state, this.isNewFlow, this.isQLPhongHop)
            };
          }
        );
      },

      stateChanged(event) {
        this.advanceSearchForm.state = event.state;
        this.doSearch();
      },

      initQuery() {
        let query = this.$route.query;
        this.advanceSearchForm.keyword = utils.getParamFromQuery(
          query,
          "keyword"
        );
        this.advanceSearchForm.state =
          utils.getParamFromQuery(query, "state") || "-1";
        this.keyword = this.advanceSearchForm.keyword;
        this.initTimeRange();
      },

      initTimeRange() {
        utils.timeRangeChanged(
          dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
          ),
          (from_, to_) => {
            this.advanceSearchForm.startTime = from_;
            this.advanceSearchForm.endTime = to_;
          }
        );

        this.createTimeRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
      },

      getProcedureInformation() {
        return hanhchinhService
          .getProcedureInformation(this.flowCode)
          .then(response => {
            if (response.data.hcFlow !== null) {
              this.advanceSearchForm.hcFlowId = response.data.hcFlow.id;
            }
          });
      },

      simpleSearch(keyword) {
        this.searchKey = this.advanceSearchForm.keyword = keyword;
        this.doSearch();
      },

      buildRouteQuery() {
        return utils.merge(
          {sort: this.sort, order: this.order},
          this.advanceSearchForm
        );
      },

      convertToSearchForm() {
        return {
          key: this.advanceSearchForm.keyword,
          // status: this.advanceSearchForm.filterStatus,
          hcFlowId: this.advanceSearchForm.hcFlowId,
          startTime: this.advanceSearchForm.startTime,
          endTime: this.advanceSearchForm.endTime,
          flowCode: this.flowCode,
          requestDeptId: this.advanceSearchForm.requestDeptId,
          state:
            this.advanceSearchForm.state === "-1"
              ? null
              : this.advanceSearchForm.state
        };
      },

      doSearch() {
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: this.buildRouteQuery()
        });
        this.items = [];
        this.page = 0;
        this.$nextTick(() => {
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset();
        });
      },

      list() {
        let pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
        return hcMasterCaseRequestViewService
          .findAll(this.convertToSearchForm(), pageable)
          .then(response => {
            let items = response.data;
            items && this.items.push(...items);
            return items;
          });
      },

      openCreateDialog() {
        this.$emit("openCreateDialog");
      },

      infiniteHandler($state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });
      },

      // sort
      doSort(sort) {
        let order =
          sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
        this.sort = sort;
        this.order = order;
        this.doSearch();
      },

      // xem chi tiet
      viewDetail(e) {
        let caseMasterId = e.caseMasterId;
        this.$emit("viewDetail", {caseMasterId: caseMasterId});
      },

      loadDepartments() {
        departmentService.findAll().then(response => {
          let i = 0;
          h.each(response.data, item => {
            this.deptsFilters.push({id: item.deptCode, name: item.deptName, level: ++i})
          })
        });
      },

      viewCalendar() {
        let params = utils.merge(this.$route.params);
        this.$router.push({
          name: "adminstration-regisRoomCalendar",
          params: params,
          query: null
        });
      },
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/hc-base-index.vue